<template>
    <dashboard-container>

        <dashboard-section header="Recent Collections">

            <p class="text-gray-600">Data collections are coming soon...</p>
            
        </dashboard-section>

        <dashboard-section header="Recent Models">

            <div class="flex flex-col space-y-4" v-if="currentProject">
                <dashboard-card v-for="model in activeModels" :key="model.id">
                    <router-link tag="a" :to="{ name: 'ModelPage', params: { modelId: model.id }, query: { ...$route.query }}" class="w-full flex items-center justify-between">
                        <div class="flex items-center space-x-4">
                            <icon-svg icon="model" class="w-5"/>
                            <typography variant="p" class="font-semibold">{{ model.name }}</typography>
                        </div>
                        

                        <icon-svg icon="fat-arrow-right" class="w-4"/>
                    </router-link>
                </dashboard-card>

                <router-link :to="{ name: 'CreateModel', query: { ...this.$route.query }}" v-show="!activeModels.length" class="self-start transition duration-150 text-secondary dark:text-secondary-300 hover:text-secondary-300 dark-hover:text-secondary-400 focus:outline-none focus:shadow-outline rounded-sm flex items-center">
                    
                    <icon-svg icon="model" class="w-4 mr-3"/>

                    Deploy your first model...
                </router-link>
            </div>
            
        </dashboard-section>

    </dashboard-container>
</template>

<script>
import { LayoutComponents } from '@/modules/Dashboard/components'
import { currentProject, loading } from '@/mixins'

export default {
    name: "Dashboard",
    metaInfo() {
        return {
            title: this.currentProject ? this.currentProject.name : 'Project'
        }
    },
    data () {
        return {
        }
    },
    mixins: [ LayoutComponents, currentProject, loading ],
}
</script>